// Helper per il download lato client di file generati dal backend (export
// calendario in Excel/PDF). Funzioni pure di utilità DOM, condivise tra pagine.

// Forza il download di un Blob creando un <a> temporaneo.
export const downloadBlob = (blob: Blob, filename: string): void => {
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.setTimeout(() => URL.revokeObjectURL(url), 0);
};

// Normalizza una stringa per usarla come nome file (minuscole, solo a-z0-9 e _).
export const toSafeFilename = (value: string): string =>
  value
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "") || "evento";
